"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.contractToTokenData = contractToTokenData;
exports.findEvents = findEvents;
exports.getTokenData = getTokenData;
var _chains = require("@blockwell/chains");
function findEvents(submission, match) {
  let test;
  if (match instanceof RegExp) {
    test = val => match.test(val);
  } else {
    test = val => match === val;
  }
  let events = [];
  for (let step of submission.data.steps) {
    if (step.completed() && step.events && step.events.length > 0) {
      for (let it of step.events) {
        if (!it) {
          continue;
        }
        if (it.event && test(it.event)) {
          events.push({
            event: it,
            step
          });
        }
      }
    }
  }
  return events;
}
function contractToTokenData(contract) {
  return {
    name: contract.name,
    symbol: contract.parameters.symbol,
    decimals: contract.parameters.decimals,
    network: (0, _chains.getChain)(contract.network).chainId,
    address: contract.address,
    bwtype: contract.bwtype,
    bwver: contract.bwver
  };
}
function getTokenData(contracts, chain, address) {
  return contracts.getContract({
    chainId: chain,
    address
  }).then(contractToTokenData);
}
//# sourceMappingURL=util.js.map